import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import convertToNestedArray from "@sourceflow-uk/functions/convertToNestedArray";
import data from "@sourceflow/top_menu.json";

export const useTopMenu = () => convertToNestedArray(useSourceFlowCollection(data));

export default useTopMenu;
